import React from 'react';
import { motion } from 'framer-motion';
import { Logo } from '../ui/Logo';
import { Mail, Globe, ArrowRight } from 'lucide-react';
export function ContactSlide() {
  return <div className="w-full h-full bg-bg-dark text-white flex flex-col items-center justify-center relative overflow-hidden" data-id="element-281" data-mp="11aasjyfd7spv">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-282" data-mp="wi18v04ufow1">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-primary-light/20 via-bg-dark to-bg-dark" data-id="element-283" data-mp="1b7z0jq1zewpz" />
      </div>

      <div className="relative z-10 flex flex-col items-center text-center max-w-4xl px-6" data-id="element-284" data-mp="1k96pvimisn7x">
        <motion.div initial={{
        scale: 0.8,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        duration: 0.8
      }} className="mb-12" data-id="element-285" data-mp="1fa2dyk87obdw">
          <Logo variant="light" size="xl" className="justify-center" data-id="element-286" data-mp="3h3jgj9hhim1s" />
        </motion.div>

        <motion.h2 className="text-3xl md:text-5xl font-bold mb-6 leading-tight" initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.3
      }} data-id="element-287" data-mp="2l8o10sah45v7">
          Starten wir mit Schritt 1: <br data-id="element-288" data-mp="341rzcqymz6w5" />
          <span className="text-accent" data-id="element-289" data-mp="3408h4utf6lrq">der Analyse Ihrer Prozesse.</span>
        </motion.h2>

        <motion.p className="text-xl text-gray-300 mb-12" initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.5
      }} data-id="element-290" data-mp="38zk08ah9e3ch">
          Wir freuen uns auf Ihr Projekt.
        </motion.p>

        <motion.a href="https://calendly.com/intigoo/erstgespraech" target="_blank" rel="noopener noreferrer" className="group bg-accent hover:bg-accent-dark text-white font-bold py-4 px-10 rounded-full text-lg transition-all duration-300 flex items-center gap-3 shadow-lg hover:shadow-accent/20 hover:scale-105" initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.7
      }} whileTap={{
        scale: 0.95
      }} data-id="element-291" data-mp="1jnrm5yofhc3f">
          Gespräch vereinbaren
          <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-292" data-mp="1uj1ynd818bxg" />
        </motion.a>

        <motion.div className="mt-16 flex flex-col md:flex-row gap-8 text-gray-400" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1
      }} data-id="element-293" data-mp="297pqp9io63in">
          <div className="flex items-center gap-3 hover:text-white transition-colors" data-id="element-294" data-mp="2e8vjt8g8rssp">
            <Mail className="w-5 h-5" data-id="element-295" data-mp="2wwxpjlhi0b6j" />
            <span data-id="element-296" data-mp="2wtryi0pb6z86">info@intigoo.de</span>
          </div>
          <div className="flex items-center gap-3 hover:text-white transition-colors" data-id="element-297" data-mp="31twii0pfec35">
            <Globe className="w-5 h-5" data-id="element-298" data-mp="2nvpvjfm0lwi9" />
            <span data-id="element-299" data-mp="2nuwtgry03v6g">www.intigoo.de</span>
          </div>
        </motion.div>
      </div>
    </div>;
}